import { AmbientLight, DirLight } from "@xeokit/xeokit-sdk";
import { Shadow } from "@xeokit/xeokit-sdk/src/viewer/scene/lights/Shadow.js";

const setupLights = (viewer) => {
  // Clear the scene's default light
  viewer.scene.clearLights();

  // Create a Shadow instance
  const shadow = new Shadow(viewer.scene, {
    intensity: 2, // Shadow intensity (0 to 1)
    resolution: 2048, // Shadow resolution (higher = better quality)
  });

  // Add custom ambient light
  new AmbientLight(viewer.scene, {
    color: [0.5, 0.5, 0.5],
    intensity: 0.5,
  });

  // Add custom Directional Lights (Key, Fill, and Rim lights)
  new DirLight(viewer.scene, {
    id: "fillLight",
    dir: [-0.8, -0.4, -0.4], // Direction of the light
    color: [0.8, 0.8, 0.8], // Greenish light
    intensity: 0.8, // Brightness
    space: "view",
  });

  new DirLight(viewer.scene, {
    id: "rimLight",
    dir: [0.2, -0.8, 0.8], // Direction of the light
    color: [0.6, 0.6, 0.6], // Soft gray light
    intensity: 0.8, // Brightness
    space: "view",
  });

  new DirLight(viewer.scene, {
    id: "keyLight",
    dir: [-1, -1, -1], // Direction of the light
    color: [1.0, 1.0, 1.0], // Reddish light
    intensity: 1.5, // Brightness
    castsShadow: true,
    shadow: shadow,
    space: "view",
  });
};

export default setupLights;